import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const RadioGroup = styled.div`
	padding-top: 24px;
`;

export const InnerGroup = styled.div`
	padding-left: 24px;
`;

export const RadioWrapper = styled.div`
	padding: 10px 0px;

	span + span {
		font-weight: normal;
		font-size: 16px;
		line-height: 24px;
		color: ${colors.grey8};
		padding-left: 16px !important;
	}
`;

export const InnerWrapper = styled(RadioWrapper)`
	padding: 8px 0px;
`;

export const HelperText = styled.span`
	padding-left: 16px;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.amber};
`;
